<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, RouterView } from 'vue-router';
import AppFooter from '@/components/AppFooter.vue';

const route = useRoute();
// O mapa é fullscreen — footer só nas telas comuns (login, etc).
// O versículo + "Para a glória de Deus" aparece nessas telas (regra RTI).
const showFooter = computed(() => route.name !== 'map');
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <main class="flex-1 flex flex-col">
      <RouterView />
    </main>
    <AppFooter v-if="showFooter" />
  </div>
</template>
